
const MN_LINKS = {
    MN_NEW_CUSTOMERS: 'https://www.mnsure.org/new-customers/apply/index.jsp',
    MN_REPORT_CHANGE: 'https://www.mnsure.org/current-customers/manage-account/report-change/private.jsp',
    MN_CONTACT_US: 'https://www.mnsure.org/help/index.jsp',
    MN_DOCUMENTS: 'https://www.mnsure.org/documents/index.jsp',
    MN_MY_ELIGIBILITY_HOME: '${MANAGE_ASSISTER}/CitizenPortal/application.do?CitizenAccountHome',
    TERM_AND_CONDITION: 'https://www.mnsure.org/resources/terms-conditions.jsp',
    CLAIM_NOTICE_LINK:'https://www.mnsure.org/current-customers/rights/rights-public.jsp#liens%20claims',
    CUSTOMER_RIGHTS: 'https://www.mnsure.org/current-customers/rights/',
    CONSENT_SHARE_LINK: 'https://www.mnsure.org/current-customers/rights/rights-public.jsp#consent_share',
    ASSIGN_BENEFITS_LINK: 'https://www.mnsure.org/current-customers/rights/rights-public.jsp#liens%20claims',
    ESTATE_RECOVERY_LINK: 'https://www.mnsure.org/current-customers/rights/rights-public.jsp#liens%20claims',
    OUTSIDE_PARENT_LINK: 'https://www.mnsure.org/current-customers/rights/rights-public.jsp#medical_support',
    TRIBAL_AGENCY_LINK: 'https://mn.gov/dhs/people-we-serve/adults/health-care/health-care-programs/contact-us/county-tribal-state-offices.jsp',
    MEDICAL_ASSISTANCE_LINK: 'https://mn.gov/dhs/people-we-serve/adults/health-care/health-care-programs/programs-and-services/medical-assistance.jsp',
    MEDICAL_ASSISTANCE_TEFRA_LINK: 'https://mn.gov/dhs/people-we-serve/people-with-disabilities/health-care/health-care-programs/programs-and-services/ma-tefra.jsp',
    MEDICAL_ASSISTANCE_DISABILITY_LINK: 'https://mn.gov/dhs/people-we-serve/people-with-disabilities/health-care/health-care-programs/programs-and-services'
};

const ID_LINKS = {
    DOWNLOAD_APPEALS_FORM: 'https://www.yourhealthidaho.org/filing-an-appeal/',
    DEFAULT_SURVEY_LINK: 'https://www.surveymonkey.com/r/XHHPYRD',
    ROLE_BASED_LINK: 'https://www.surveymonkey.com/r/9L9VDM8',
    DESIGNATE_REPRESENTATIVE: 'https://www.yourhealthidaho.org/designate-an-agent/'
};


const NV_LINKS = {
    USER_GUIDES: 'https://www.nevadahealthlink.com/user-guides/',
    ESTATE_RECOVERY_LINK: 'https://www.medicaid.gov/',
    IMMIGRATION_STATUS_LINK: 'https://help.nevadahealthlink.com/hc/en-us/articles/360028568792',
    RECONCILE_APTC: 'https://help.nevadahealthlink.com/hc/en-us/articles/360028568612-How-to-reconcile-your-premium-tax-credit'
};

const NJ_LINKS = {
    CLAIM_NOTICE_LINK:
        'https://www.nj.gov/humanservices/dmahs/documents/individuals-families/The_NJ_Medicaid_Program_and_Estate_Recovery_What_You_Should_Know.pdf',
    ESTATE_RECOVERY_LINK:
        'https://www.nj.gov/humanservices/dmahs/documents/individuals-families/The_NJ_Medicaid_Program_and_Estate_Recovery_What_You_Should_Know.pdf',
    EXCEPTIONAL_CIRCUMSTANCES_ATTESTATION_FORM: 'https://nj.gov/getcoverednj/getstarted/buy/sepexcepcirattestation.pdf',
    FAMILY_CARE: 'http://www.NJFamilyCare.org',
    GET_COVERED: 'https://nj.gov/getcoverednj/',
    HELP_LINK_EN: 'https://nj.gov/getcoverednj/findanswers/faqs',
    HELP_LINK_ES: 'https://nj.gov/getcoverednj/espanol/findanswers/faqs',
};

const PA_LINKS = {
    CONNECT: 'https://pennie.com/connect/',
    FAQ: 'https://pennie.com/learn/faqs/',
    VOTER_REGISTRATION: 'https://pennie.com/voterregistration/',
    ORGAN_DONOR_REGISTRATION: 'https://pennie.com/organdonor/'
};

const IL_LINKS = {
    CONNECT: 'https://getcovered.illinois.gov/connect/',
    FAQ: 'https://getcovered.illinois.gov/learn/faqs/',
    VOTER_REGISTRATION: {
        en: 'https://getcovered.illinois.gov/en/voter-registration',
        es: 'https://getcovered.illinois.gov/es/registro-de-votantes'
    },
    ORGAN_DONOR_REGISTRATION: 'https://getcovered.illinois.gov/organdonor/'
};

const OR_LINKS = {
    CONNECT: 'https://oregon.gov/connect/',
    FAQ: 'https://oregon.gov/learn/faqs/',
    IMMIGRATION_STATUS_LINK: 'https://explorehealthor.gov/immigration',
    VOTER_REGISTRATION: {
        en: 'https://oregon.gov/en/voter-registration',
        es: 'https://oregon.gov/es/registro-de-votantes'
    },
    ORGAN_DONOR_REGISTRATION: 'https://oregon.gov/organdonor/'
};

const VA_LINKS = {
    VOTER_REGISTRATION: 'https://www.marketplace.virginia.gov/vote',
};

const GI_LINKS = {
    VOTER_REGISTRATION: 'https://www.vimo.com/',
};

const GA_LINKS = {
    AGENTS_LINK: 'https://georgiaaccess.gov/for-partners/agents/',
    ESTATE_RECOVERY_LINK: 'https://medicaid.georgia.gov/programs/third-party-liability/medicaid-estate-recovery',
    VOTER_REGISTRATION: {
        en: 'https://mvp.sos.ga.gov/s/',
        es: 'https://mvp.sos.ga.gov/s/'
    }
};

const NM_LINKS = {
    BEWELL_APPT: 'https://bewellnm.com/appointment'
};

const GENERAL = {
    HEALTH_CARE_GOV: 'https://www.healthcare.gov/',
    DEFAULT_SURVEY_LINK: 'https://www.surveymonkey.com/r/57CVPF3',
    USPS_GENERAL_DELIVERY: 'https://faq.usps.com/s/article/What-is-General-Delivery',
    HEALTH_CARE_GOV_REPORTING_DEDUCTIONS: {
        en: 'https://www.healthcare.gov/reporting-deductions/',
        es: 'https://www.cuidadodesalud.gov/es/reporting-deductions/'
    }
};
export const CHIP_ELIGIBLE_LINKS = {
    MN: 'https://mn.gov/dhs/people-we-serve/adults/health-care/health-care-programs/'
};
export const MEDICAID_ELIGIBLE_LINKS = {
    ID: 'https://idalink.idaho.gov/',
    MN: 'https://mn.gov/dhs/people-we-serve/adults/health-care/health-care-programs/',
    GA: 'https://gateway.ga.gov/access/',
    NV: 'https://www.google.com/'
};

export const MEDICARE_ELIGIBLE_LINKS = {
    GA: 'https://www.medicare.gov/',
    ID: 'https://doi.idaho.gov/shiba/',
    MN: 'http://www.seniorlinkageline.com',
    NJ: 'https://www.medicare.gov/',
    NV: 'https://help.nevadahealthlink.com/hc/en-us/articles/360028558952-Medicare',
    PA: 'https://help.pennie.com/hc/en-us/articles/360049727073-Medicare'
};

export const HOTLINE = {
    GA: 'tel:877-423-4746',
    MN: 'tel:877-423-4746'
};

export const PAGE_TITLE = {
    GA: 'Compare Health Insurance Plans and Prices - Georgia Access',

};

const MN_FS_LINKS = {
    MN_ACCOUNT_REQUEST_FORM: 'https://www.mnsure.org/forms/account-request-form.jsp',
};


export default {
    GENERAL,
    ID_LINKS,
    IL_LINKS,
    OR_LINKS,
    MN_LINKS,
    NJ_LINKS,
    NM_LINKS,
    NV_LINKS,
    PA_LINKS,
    GA_LINKS,
    MN_FS_LINKS,
    VA_LINKS,
    GI_LINKS,
};
